import {
  RECEIVE_TEAMS,
} from '../constants';

import TeamApi from '../api/TeamApi'

export const receiveTeams = (teams) => {
  return {
    type: RECEIVE_TEAMS,
    teams
  }
}


export const fetchTeams = () => {
  return(dispatch) => {
    return TeamApi.index().then(response => {
      dispatch(receiveTeams(response))
    })
  }
}


// WEBPACK FOOTER //
// ./src/shared/javascripts/actions/teamActions.js